import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Future: send to error tracking service (e.g. Sentry)
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  handleGoHome = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = "/dashboard";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            padding: "2rem",
            textAlign: "center",
            fontFamily: "inherit",
          }}
        >
          <h1 style={{ fontSize: "2rem", marginBottom: "1rem", color: "#495057" }}>
            Something went wrong
          </h1>
          <p style={{ color: "#74788d", marginBottom: "2rem", maxWidth: "500px" }}>
            An unexpected error occurred. Please try reloading the page or go
            back to the dashboard.
          </p>
          <div style={{ display: "flex", gap: "1rem" }}>
            <button
              onClick={this.handleReload}
              style={{
                padding: "0.5rem 1.5rem",
                backgroundColor: "#556ee6",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "0.9rem",
              }}
            >
              Reload Page
            </button>
            <button
              onClick={this.handleGoHome}
              style={{
                padding: "0.5rem 1.5rem",
                backgroundColor: "#f8f9fa",
                color: "#495057",
                border: "1px solid #ced4da",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "0.9rem",
              }}
            >
              Go to Dashboard
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
